import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "gf_admin_token";

const adminClient = axios.create({ baseURL: API });
adminClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const adminLogin = (email, password) => adminClient.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => adminClient.get("/auth/me").then((r) => r.data);

export const getSummary = () => adminClient.get("/admin/summary").then((r) => r.data);
export const getSubmissions = (kind) => adminClient.get("/admin/submissions", { params: kind ? { kind } : {} }).then((r) => r.data);
export const deleteSubmission = (id) => adminClient.delete(`/admin/submissions/${id}`).then((r) => r.data);

export const adminGetBlog = () => adminClient.get("/admin/blog").then((r) => r.data);
export const createBlog = (d) => adminClient.post("/admin/blog", d).then((r) => r.data);
export const updateBlog = (id, d) => adminClient.put(`/admin/blog/${id}`, d).then((r) => r.data);
export const deleteBlog = (id) => adminClient.delete(`/admin/blog/${id}`).then((r) => r.data);

export const adminGetTestimonials = () => adminClient.get("/admin/testimonials").then((r) => r.data);
export const createTestimonial = (d) => adminClient.post("/admin/testimonials", d).then((r) => r.data);
export const updateTestimonial = (id, d) => adminClient.put(`/admin/testimonials/${id}`, d).then((r) => r.data);
export const deleteTestimonial = (id) => adminClient.delete(`/admin/testimonials/${id}`).then((r) => r.data);
